import { FilePreview } from './FilePreview';
import { ImagePreview } from './ImagePreview';
import { VideoPreview } from './VideoPreview';
import type { AttachmentItem } from '@/types/attachment';

interface AttachmentPreviewProps {
  attachments: AttachmentItem[];
  onRemove: (id: string) => void;
}

export function AttachmentPreview({ attachments, onRemove }: AttachmentPreviewProps) {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <div className="rounded-2xl border border-border/60 bg-card/60 p-3 shadow-sm backdrop-blur-sm">
      <div className="flex flex-wrap gap-3">
        {attachments.map((attachment) => {
          if (attachment.kind === 'image') {
            return <ImagePreview key={attachment.id} attachment={attachment} onRemove={onRemove} />;
          }

          if (attachment.kind === 'video') {
            return <VideoPreview key={attachment.id} attachment={attachment} onRemove={onRemove} />;
          }

          return <FilePreview key={attachment.id} attachment={attachment} onRemove={onRemove} />;
        })}
      </div>
    </div>
  );
}
